/* @flow */

import type { TCity } from '../types/city';

export const getCityByCityIds = (ids: ?Array<number> | ?number | ?string, cities): ?TCity => {
	if (
		ids === null ||
		ids === undefined ||
		(!Array.isArray(ids) && typeof ids !== 'number' && typeof ids !== 'string')
	) {
		return null;
	}

	const id = Array.isArray(ids) ? Number(ids[0]) : Number(ids);
	return cities.find((cityItem) => cityItem.cityIds.includes(id));
};

export function getCityTitleByCityIds(ids: ?Array<number> | ?number | ?string, cities): ?string {
	const city = getCityByCityIds(ids, cities);

	return city ? city.title : null;
}

export function getCityLinkByCityIds(ids: ?Array<number> | ?number | ?string, cities): ?string {
	const city = getCityByCityIds(ids, cities);

	return city ? city.link : null;
}
